"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IERC721Receiver__factory", {
  enumerable: true,
  get: function get() {
    return _IERC721Receiver__factory.IERC721Receiver__factory;
  }
});
var _IERC721Receiver__factory = require("./IERC721Receiver__factory");